module.exports = __webpack_public_path__ + "static/media/guide_step3.8b999104.png";